(function () {
  'use strict';

  function fixGalleryGap() {
    var grid = document.querySelector('.product.grid, .product.grid--2-col-tablet');
    var wrapper = document.querySelector('.product__media-wrapper');
    var gallery = document.querySelector('media-gallery');
    var viewer = document.querySelector('[id^="GalleryViewer"]');
    var mediaList = viewer && viewer.querySelector('.product__media-list');
    var thumbs = document.querySelector('[id^="GalleryThumbnails"]');

    /* --- Outer layout --- */
    if (grid) grid.style.setProperty('align-items', 'start', 'important');

    if (wrapper) {
      wrapper.style.setProperty('align-self', 'start', 'important');
      wrapper.style.setProperty('height', 'auto', 'important');
      wrapper.style.setProperty('min-height', '0', 'important');
      wrapper.style.setProperty('max-height', 'none', 'important');
    }

    if (gallery) {
      gallery.style.setProperty('display', 'flex', 'important');
      gallery.style.setProperty('flex-direction', 'column', 'important');
      gallery.style.setProperty('height', 'auto', 'important');
      gallery.style.setProperty('min-height', '0', 'important');
    }

    if (viewer) {
      viewer.style.setProperty('flex', '0 0 auto', 'important');
      viewer.style.setProperty('height', 'auto', 'important');
      viewer.style.setProperty('min-height', '0', 'important');
      viewer.style.setProperty('max-height', 'none', 'important');
      viewer.style.setProperty('margin-bottom', '0', 'important');
      viewer.style.setProperty('padding-bottom', '0', 'important');
    }

    if (mediaList) {
      mediaList.style.setProperty('height', 'auto', 'important');
      mediaList.style.setProperty('min-height', '0', 'important');
      mediaList.style.setProperty('margin-bottom', '0', 'important');
      mediaList.style.setProperty('padding-bottom', '0', 'important');
    }

    if (thumbs) {
      thumbs.style.setProperty('flex', '0 0 auto', 'important');
      thumbs.style.setProperty('margin-top', '8px', 'important');
      thumbs.style.setProperty('padding-top', '0', 'important');
    }

    /* --- Slide-level fixes ---
       The CSS file sets aspect-ratio:1 on slides.
       JS ensures no theme script can override height with px values. */
    if (viewer) {
      viewer.querySelectorAll('.slider__slide, .product__media-item').forEach(function (el) {
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });

      /* Inner containers — fill their 1:1 slide */
      viewer.querySelectorAll('.product-media-container').forEach(function (el) {
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.removeProperty('padding-bottom');
        el.style.removeProperty('aspect-ratio');
      });

      viewer.querySelectorAll('.product__modal-opener').forEach(function (el) {
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('display', 'block', 'important');
      });

      viewer.querySelectorAll('.product__media.media').forEach(function (el) {
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('padding-top', '0', 'important');
        el.style.setProperty('padding-bottom', '0', 'important');
        el.style.setProperty('position', 'static', 'important');
        el.style.removeProperty('aspect-ratio');
      });

      /* Images: fill their container; object-fit:contain handles any
         portrait/landscape images without distortion */
      viewer.querySelectorAll('.product__media.media img').forEach(function (el) {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('object-fit', 'contain', 'important');
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('display', 'block', 'important');
        el.style.removeProperty('top');
        el.style.removeProperty('left');
      });
    }
  }

  /* Run immediately */
  fixGalleryGap();

  /* Staggered retries to catch deferred renders */
  [50, 100, 200, 400, 800, 1500, 3000].forEach(function (t) {
    setTimeout(fixGalleryGap, t);
  });

  /* DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGalleryGap);
  }

  /* Full load + slight delay */
  window.addEventListener('load', function () {
    fixGalleryGap();
    setTimeout(fixGalleryGap, 300);
  });

  /* MutationObserver — re-run when gallery DOM or styles change */
  var mo = new MutationObserver(function () {
    fixGalleryGap();
  });

  function startObserver() {
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      mo.observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  window.addEventListener('resize', fixGalleryGap);
})();
